
    import {Component, Prop, Vue} from 'vue-property-decorator'
    import { getSyDictDataInfo } from '@/api/commonConfig'

    @Component({
        name: 'TypeFilters'
    })
    export default class TypeFilters extends Vue {
        @Prop({default: false}) isShowAll!: boolean // 是否显示所有级别
        @Prop({default: true}) isShowReset!: boolean // 是否显示清空
        @Prop({default: false}) isShowAdd!: boolean // 是否直接显示新增按钮
        @Prop({default: '客户类别筛选'}) title!: boolean // 标题

        showTemp = false
        companyId = ''
        merchantsTypeList: any[] = []
        dataId = ''

        mounted () {
        }


        /**
         * 获取merchantsType选项数据【字典接口】
         * @param name 查询参数
         * @param list 存放地址(Array类型)
         */
        dictList () {
          let param = {
            dictTypeId: 'merchantsType'
          }
          getSyDictDataInfo(param).then(res => {
            this.merchantsTypeList = res.data
          })
        }

        show (options: { companyId: string, dataId: string }) {
            this.companyId = options.companyId
            this.dataId = options.dataId
            this.dictList()
            this.showTemp = true
        }

        hide () {
            this.showTemp = false
        }

        sureFunc () {
            const data = this.merchantsTypeList.filter(item => { return item.dataId === this.dataId })
            this.$emit('getDataId', this.dataId,  data && data.length > 0 ? data[0] : {})
            this.hide()
        }

        resetFunc () {
            this.dataId = ''
            this.$emit('getDataId', this.dataId, {})
            this.hide()
        }

        changeTag (id: string) {
           this.dataId = id
        }

        toSetting () {
            this.hide()
            this.$nextTick(() => {
                this.$router.push('/levelSetting')
            })
        }
        toAdd () {
            this.$router.push({
                path: '/levelHandle',
                query: {
                    isAdd: '1'
                }
            })
        }
    }
